export default [
  /* -------------- 个人中心 ----------- */
  {
    path: '/personal-center',
    name: 'PersonalCenter',
    component: () => import(/* webpackChunkName: "personal" */ '@/views/PersonalCenter/personalCenter'),
    meta: {
      singlePage: true, // 不在Main中显示
    }
  },
]
